import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function createContractBpmFunc(requestBody) {
  return request({
    url: URL.mdm.contractBpm.createContractBpmUrl,
    method: 'post',
    data: requestBody
  })
}

export function getWorkFlowContract(params) {
  return request({
    url: URL.mdm.contractBpm.getWorkFlowContractUrl,
    method: 'get',
    params
  })
}
